@if (profileField$ | async; as profileField) {
  <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" style="{{ nestedPadding$ | async }}">
    <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="labelIcons"></sh-field-label>
  </dt>
  @if (value$ | async; as value) {
    <ng-container
            *ngTemplateOutlet="
                canSearchOnClick(profileField.FieldDefinition) ? searchableData : nonSearchableData;
                context: { value: value, fieldDefinition: profileField.FieldDefinition }
            "
      >
    </ng-container>
  } @else {
    <dd class="sh-description-list__details">-</dd>
  }
}

<ng-template #searchableData let-value="value" let-fieldDefinition="fieldDefinition">
  <dd [routerLink]="searchRouterLink" [queryParams]="getSearchRouterParams(fieldDefinition, value)" class="sh-link sh-description-list__details">
    {{ value | date: "dd MMM yyyy" }}
  </dd>
</ng-template>

<ng-template #nonSearchableData let-value="value">
  <dd class="sh-description-list__details">{{ value | date: "dd MMM yyyy" }}</dd>
</ng-template>

